import React from 'react'
import Grid from '@mui/material/Grid'
import Typography from '@mui/material/Typography'
import FormControl from '@mui/material/FormControl'
import InputLabel from '@mui/material/InputLabel'
import Select from '@mui/material/Select'
import MenuItem from '@mui/material/MenuItem'
import Autocomplete from '@mui/material/Autocomplete'
import TextField from '@mui/material/TextField'
import Paper from '@mui/material/Paper'

const AirwayAssess = ({ moduleValues, setModuleValues }) => (

    <Grid item xs={12} lg={6}>
      <FormControl fullWidth>
        <InputLabel>Airway Patency</InputLabel>
        <Select
          value={moduleValues?.['Airway Patency'] ?? ''}
          onChange={(e) =>setModuleValues(prev => ({...prev, ['Airway Patency']: e.target.value}))
          }
          label="Airway Patency"
        >
          <MenuItem value="Talking">Talking</MenuItem>
          <MenuItem value="Patent">Patent</MenuItem>
          <MenuItem value="Partial Obstruction">Partial Obstruction</MenuItem>
          <MenuItem value="Snoring">Snoring</MenuItem>
          <MenuItem value="Complete Obstruction">Complete Obstruction</MenuItem>
        </Select>
      </FormControl>
    </Grid>

)

export default AirwayAssess
